import React from "react";
import Navbar from "./Navbar";

const PricingPage = () => {
  return (
    <>
      <style>{`

        body {
          margin: 0;
        }

        .pricing-section {
          background: #EFFFE1;
          padding: 60px 20px;
        }

        .container {
          max-width: 1300px;
          margin: auto;
        }

        .heading {
          text-align: center;
          font-size: 38px;
          font-weight: 700;
          color: #0F3D2E;
          margin-bottom: 70px;
        }

        /* GRID */

        .grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 28px;
        }

        /* CARD */

        .card {
          background: #DCF6C6;
          border-radius: 20px;
          padding: 30px 24px;
          box-shadow: 0 15px 40px rgba(0,0,0,0.08);
          transition: all 0.3s ease;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .card:hover {
          transform: translateY(-10px);
          box-shadow: 0 25px 50px rgba(0,0,0,0.12);
        }

        /* REMOVE DARK GREEN COMPLETELY */

        .highlight {
          background: #DCF6C6;
          color: inherit;
          transform: none;
        }

        .highlight h3,
        .highlight p,
        .highlight li {
          color: inherit;
        }

        /* TEXT */

        .card h3 {
          font-size: 22px;
          margin-bottom: 10px;
          color: #0F3D2E;
        }

        .section-title {
          font-size: 14px;
          font-weight: 600;
          margin-top: 18px;
          margin-bottom: 6px;
          color: #145A32;
        }

        .card ul {
          padding-left: 16px;
        }

        .card li {
          font-size: 13px;
          margin-bottom: 5px;
          color: #1C1C1C;
          line-height: 1.5;
        }

        /* BUTTON */

.btn {
  background: #7ED957;
  border: none;
  padding: 10px 18px;
  border-radius: 999px;
  cursor: pointer;
  font-weight: 500;

  text-decoration: none;   /* removes underline */
  display: inline-block;   /* makes <a> behave like button */
  color: black;            /* ensures text color */
}

        .btn:hover {
          background: #5cc43c;
          color: white;
        }

        /* RESPONSIVE */

        @media (max-width: 1100px) {
          .grid {
            grid-template-columns: 1fr 1fr;
          }
        }

        @media (max-width: 600px) {
          .grid {
            grid-template-columns: 1fr;
          }

          .heading {
            font-size: 28px;
          }
        }

      `}</style>

      <Navbar />

      <section className="pricing-section">
        <div className="container">

          <h2 className="heading">
            Choose a Plan That’s Right for Your Business
          </h2>

          <div className="grid">

            {/* GOLD */}
            <div className="card">
              <div>
                <h3>Gold Pack</h3>

                <p className="section-title">Company Registration</p>
                <ul>
                  <li>Private Ltd: ₹14,000 – ₹35,000</li>
                  <li>LLP: ₹9,000 – ₹23,000</li>
                  <li>Proprietorship: ₹999 – ₹4,999</li>
                </ul>

                <p className="section-title">GST Services</p>
                <ul>
                  <li>GST Registration: ₹2,000 – ₹4,000</li>
                  <li>GST Return Filing: ₹1,000 – ₹3,000</li>
                  <li>GST Notice Reply: ₹2,999 – ₹9,999</li>
                </ul>

                <p className="section-title">Income Tax</p>
                <ul>
                  <li>Individuals: ₹500 – ₹2,500</li>
                  <li>Business: ₹2,500 – ₹10,000</li>
                </ul>

                <p className="section-title">TDS / TCS</p>
                <ul>
                  <li>Return: ₹1,000 – ₹5,000</li>
                  <li>Monthly: ₹2,000 – ₹8,000</li>
                </ul>

                <p className="section-title">Accounting</p>
                <ul>
                  <li>Small: ₹2,000 – ₹10,000 / month</li>
                  <li>Medium: ₹10,000 – ₹25,000 / month</li>
                </ul>
              </div>

             <a href="https://wa.me/919454332268?text=Hi%20I%20am%20interested%20in%20Gold%20plan" target="_blank" rel="noreferrer" className="btn" style={{textDecoration:"none"}}>
  Get Started
</a>
            </div>

            {/* DIAMOND */}
            <div className="card">
              <div>
                <h3>Diamond Pack</h3>

                <p className="section-title">Income Tax Audit</p>
                <ul>
                  <li>0–1 Cr: ₹15,000 – ₹30,000</li>
                  <li>1–5 Cr: ₹30,000 – ₹60,000</li>
                  <li>5–20 Cr: ₹60,000 – ₹1,20,000</li>
                  <li>20+ Cr: ₹1,20,000 – ₹3,00,000+</li>
                </ul>

                <p className="section-title">GST Audit & Advisory</p>
                <ul>
                  <li>Audit: ₹10,000 – ₹50,000</li>
                  <li>Advisory: ₹5,000 – ₹25,000</li>
                </ul>

                <p className="section-title">Startup Advisory</p>
                <ul>
                  <li>Consultation: ₹2,000 – ₹10,000/hr</li>
                  <li>Setup: ₹10,000 – ₹50,000</li>
                  <li>Strategy: ₹25,000 – ₹1,00,000</li>
                </ul>

                <p className="section-title">Compliance</p>
                <ul>
                  <li>Monthly: ₹5,000 – ₹25,000</li>
                  <li>Annual: ₹25,000 – ₹1,00,000</li>
                </ul>

                <p className="section-title">Virtual CFO</p>
                <ul>
                  <li>₹25,000 – ₹2,00,000 / month</li>
                </ul>
              </div>

             <a href="https://wa.me/919454332268?text=Hi%20I%20am%20interested%20in%20Gold%20plan" target="_blank" rel="noreferrer" className="btn" style={{textDecoration:"none"}}>
  Get Started
</a>
            </div>

            {/* PLATINUM */}
            <div className="card">
              <div>
                <h3>Platinum Pack</h3>

                <p className="section-title">Corporate Tax</p>
                <ul>
                  <li>₹50,000 – ₹5,00,000+</li>
                </ul>

                <p className="section-title">Business Structuring</p>
                <ul>
                  <li>₹30,000 – ₹2,00,000</li>
                </ul>

                <p className="section-title">Tax Strategy</p>
                <ul>
                  <li>₹15,000 – ₹1,00,000</li>
                </ul>

                <p className="section-title">Capital Gain</p>
                <ul>
                  <li>₹10,000 – ₹1,50,000</li>
                </ul>

                <p className="section-title">International Tax</p>
                <ul>
                  <li>₹50,000 – ₹5,00,000+</li>
                </ul>

                <p className="section-title">Audit</p>
                <ul>
                  <li>₹20,000 – ₹3,00,000+</li>
                </ul>
              </div>

             <a href="https://wa.me/919454332268?text=Hi%20I%20am%20interested%20in%20Gold%20plan" target="_blank" rel="noreferrer" className="btn" style={{textDecoration:"none"}}>
  Get Started
</a>
            </div>

            {/* ENTERPRISE */}
            <div className="card">
              <div>
                <h3>Enterprise</h3>

                <p className="section-title">Advance Tax</p>
                <ul>
                  <li>₹25,000 – ₹1,50,000</li>
                </ul>

                <p className="section-title">Cross-Border</p>
                <ul>
                  <li>₹75,000 – ₹5,00,000+</li>
                </ul>

                <p className="section-title">M&A</p>
                <ul>
                  <li>₹1,00,000 – ₹10,00,000+</li>
                </ul>

                <p className="section-title">Family Office</p>
                <ul>
                  <li>₹1,00,000 – ₹50,00,000+</li>
                </ul>

                <p className="section-title">Wealth Structuring</p>
                <ul>
                  <li>₹50,000 – ₹3,00,000</li>
                </ul>

                <p className="section-title">IPO Advisory</p>
                <ul>
                  <li>₹2,00,000 – ₹20,00,000+</li>
                </ul>

                <p className="section-title">Startup Funding</p>
                <ul>
                  <li>₹30,000 – ₹2,00,000</li>
                </ul>
              </div>

             <a href="https://wa.me/919454332268?text=Hi%20I%20am%20interested%20in%20Gold%20plan" target="_blank" rel="noreferrer" className="btn" style={{textDecoration:"none"}}>
  Get Started
</a>
            </div>

          </div>

        </div>
      </section>

    </>
  );
};

export default PricingPage;